import { useState, useEffect } from 'react';
import { useParams } from 'react-router';
import { useTheme } from '@mui/material/styles';
import { Stack, Typography } from '@mui/material';

import { useBoolean } from 'src/hooks/use-boolean';
import { API_CONFIG } from 'src/config/api';

import { Main } from './main';
import { NavMobile } from './nav/mobile';
import { EstablishmentFooter } from './footer';
import { HeaderBase } from '../core/header-base';
import { LayoutSection } from '../core/layout-section';
import { navData as mainNavData } from '../config-nav-main';

// ----------------------------------------------------------------------

export function EstablishmentLayout({ sx, data, children }) {
  const theme = useTheme();
  const { id } = useParams();
  const mobileNavOpen = useBoolean();
  const navData = data?.nav ?? mainNavData;

  const [establishment, setEstablishment] = useState(null);

  useEffect(() => {
    if (!id) return;
    fetch(`${API_CONFIG.BASE_URL}/api/estabelecimento/${id}`)
      .then((r) => r.json())
      .then(setEstablishment)
      .catch(() => {});
  }, [id]);

  const logoSlot = (
    <Stack direction="row" alignItems="center" spacing={1.5} sx={{ textDecoration: 'none' }}>
      {establishment?.avataarUri && (
        <img
          src={establishment.avataarUri}
          alt={establishment.nomeDoEstabelecimento}
          style={{ width: 36, height: 36, borderRadius: '50%', objectFit: 'cover' }}
        />
      )}
      <Typography
        variant="subtitle1"
        fontWeight="bold"
        sx={{ color: 'text.primary', lineHeight: 1.2 }}
      >
        {establishment?.nomeDoEstabelecimento || ''}
      </Typography>
    </Stack>
  );

  return (
    <>
      <NavMobile data={navData} open={mobileNavOpen.value} onClose={mobileNavOpen.onFalse} />

      <LayoutSection
        headerSection={
          <HeaderBase
            layoutQuery="md"
            onOpenNav={mobileNavOpen.onTrue}
            logoSlot={logoSlot}
            slotsDisplay={{
              account: false,
              helpLink: false,
              contacts: false,
              searchbar: false,
              workspaces: false,
              localization: false,
              notifications: false,
            }}
            slotProps={{ container: { maxWidth: false } }}
          />
        }
        footerSection={<EstablishmentFooter establishment={establishment} />}
        sx={sx}
      >
        <Main>{children}</Main>
      </LayoutSection>
    </>
  );
}
